import { render, staticRenderFns } from "./ModalManageList.vue?vue&type=template&id=332074f3&"
import script from "./ModalManageList.vue?vue&type=script&lang=js&"
export * from "./ModalManageList.vue?vue&type=script&lang=js&"
import style0 from "./ModalManageList.vue?vue&type=style&index=0&id=332074f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports